export default {
  imageId: 'plant',
  title: 'Es liegt in unserer Hand!',
  text: 'Die Zukunft liegt in unseren Händen. Helfen Sie mit, schwierige Entscheidungen zu treffen, um eine lebenswerte Zukunft zu schaffen.',
  button: 'Von vorne starten',
  link: 'https://www.linkedin.com/',
  linkText: 'Impressum',
}
